module.exports = __webpack_public_path__ + "46363f51c6338abc78e5a25c8796ad5d.svg";